export const SET_TOKEN = 'SET_TOKEN';
export const SET_ME = 'SET_ME';

export const setToken = (value: string) => {
    return { type: SET_TOKEN, value }
}

export const setMe = (value: any) => {
    return { type: SET_ME, value }
}
